import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.jpg";

const navLinks = [
  { href: "#services", label: "Courses" },
  { href: "#how-it-works", label: "How It Works" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const linkHref = (hash: string) => (isHome ? hash : `/${hash}`);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="container flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center gap-2" aria-label="Upgrade Skills Ltd - Home">
          <img src={logo} alt="Upgrade Skills Ltd" className="h-12 md:h-14 w-auto" width={78} height={56} loading="eager" fetchPriority="high" decoding="async" />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={linkHref(link.href)}
              className="text-sm font-bold text-foreground/80 hover:text-primary transition-colors"
            >
              {link.label}
            </a>
          ))}
          <Button asChild variant="default" className="bg-gradient-hero shadow-button hover:shadow-lg transition-shadow">
            <a href="mailto:info@upgradeskills.org">Message us</a>
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 text-foreground"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav
          id="mobile-menu"
          className="md:hidden bg-background border-t border-border animate-fade-in"
          aria-label="Mobile navigation"
        >
          <div className="container py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={linkHref(link.href)}
                className="text-base font-bold text-foreground/80 hover:text-primary py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <Button asChild variant="default" className="bg-gradient-hero shadow-button w-full mt-2">
              <a href="mailto:info@upgradeskills.org">Message us</a>
            </Button>
          </div>
        </nav>
      )}
    </header>
  );
}